<template>
  <div class="main-content businessIntelligenceChart">
    <div class="grid-wrapper content">
      <div class="section item-left">
        <div class="my-chart">
          <div class="my-chart-left">
            <span style="font-size:14px;">{{ this.$t('BusinessIntelligence.businessIntelligenceChart.myChartNum') }}（{{ myChartNumber.existing }}/{{ myChartNumber.total }}）</span>
            <el-button type="primary" @click="addChartFunc">{{ this.$t('BusinessIntelligence.businessIntelligenceChart.addChart') }}</el-button>
          </div>
          <div class="my-chart-right">
            <input v-model="myChartValue" class="set-input" :placeholder="$t('BusinessIntelligence.businessIntelligenceChart.queryChart')">
            <el-button type="primary" class="mar-left" @click="myChartList">{{ this.$t('BusinessIntelligence.common.query') }}</el-button>
          </div>
        </div>
        <el-select
          v-model="grouping"
          style="width:80px;margin:5px 0;"
          size="mini"
          @change="selectGrouping"
        >
          <el-option
            v-for="(item, index) in packetFilter"
            :key="index"
            :value="item.uuid"
            :label="item.name"
          />
        </el-select>
        <div class="chart-list">
          <el-row :gutter="10">
            <el-col v-for="(item, index) in filterList" :key="index" class="item" :span="8">
              <div style="border: 1px solid #ccc;position: relative;height:100%;">
                <iframe
                  id="bdIframe"
                  ref="myIframe"
                  loading="lazy"
                  :src="item.url"
                  frameborder="0"
                  allowtransparency
                  scrolling="no"
                  width="100%"
                  height="100%"
                />
                <div class="operation" :span="6">
                  <span>{{ item.name }}</span>
                  <span>
                    <i class="el-icon-edit" style="color:#409eff;" @click="edit(item)" />
                    <i class="el-icon-close" @click="deletes(item)" />
                  </span>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="section item-right mar-left">
        <div class="my-chart">
          <div class="my-chart-left">
            <span style="font-size:14px;">{{ $t('BusinessIntelligence.businessIntelligenceChart.standardChart') }}</span>
          </div>
          <div class="my-chart-right">
            <input v-model="standardChartValue" class="set-input" :placeholder="$t('BusinessIntelligence.businessIntelligenceChart.queryStandardChart')">
            <el-button type="primary" class="mar-left" @click="standardChartList">{{ $t('BusinessIntelligence.common.query') }}</el-button>
          </div>
        </div>
        <div class="screening">
          <div class="chart-template">
            <span class="text">{{ $t('BusinessIntelligence.businessIntelligenceChart.chartTemplate') }}</span>
            <span v-for="(item, index) in chartTemplate" :key="index" class="item" :class="{'selectColor':item.id === selectTemplateId}" @click="selectTemplate(item.id)">{{ item.name }}</span>
          </div>
          <div class="classification">
            <span class="text">{{ $t('BusinessIntelligence.businessIntelligenceChart.classification') }}</span>
            <div style="display: flex;width: 95%;flex-wrap: wrap;">
              <span v-for="(item, index) in classification" :key="index" class="item" :class="{'selectColor':item === selectClassificationName}" @click="selectClassification(item)">{{ item }}</span>
            </div>
          </div>
        </div>

        <div class="chart-list" style="margin-top:10px;">
          <el-row :gutter="10">
            <el-col v-for="(item, index) in chartStandard" :key="index" class="item" :span="8">
              <div style="border: 1px solid #ccc;position: relative;height:100%;">
                <iframe
                  id="bdIframe"
                  ref="myIframe"
                  loading="lazy"
                  :src="item.url"
                  frameborder="0"
                  allowtransparency
                  scrolling="no"
                  width="100%"
                  height="100%"
                />
                <div class="operation">
                  <span>{{ item.name }}</span>
                  <el-checkbox v-model="item.selected" style="border-color: red;" :true-label="1" :false-label="0" @change="addChartFunc('checked', item)" />
                  <i v-show="item.selected" class="disable" />
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!-- 添加定制图表 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="addingCustomCharts"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :show-close="false"
      :title="$t('BusinessIntelligence.businessIntelligenceChart.addChart')"
      :editable="true"
      width="500px"
    >
      <div class="filters">
        <el-form ref="addForm" :inline="true" :model="chartForm" label-width="100px" :rules="rules" @submit.native.prevent>
          <el-form-item :label="$t('BusinessIntelligence.businessIntelligenceChart.chartName')" prop="chartName" :show-message="false">
            <input v-model="chartForm.chartName" class="input-width set-input">
          </el-form-item>
          <el-form-item :label="$t('BusinessIntelligence.businessIntelligenceChart.chartGrouping')" prop="grouping" :show-message="false">
            <el-select v-model="chartForm.grouping" class="input-width">
              <el-option
                v-for="(item, index) in groupingList"
                :key="index"
                :label="item.name"
                :value="item.uuid"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.ChartSource')" prop="chartSource" :show-message="false">
            <el-select v-model="chartForm.chartSource" class="input-width">
              <el-option
                v-for="(item, index) in domaineNames"
                :key="index"
                :value="item"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('BusinessIntelligence.businessIntelligenceChart.chartId')" prop="chartId" :show-message="false">
            <el-input v-model="chartForm.chartId" class="input-width" />
          </el-form-item>
          <el-form-item :label="$t('BusinessIntelligence.businessIntelligenceChart.remark')" prop="remark" :show-message="false">
            <el-input v-model="chartForm.remark" type="textarea" :rows="3" class="input-width" />
          </el-form-item>
        </el-form>
        <div style="text-align:right;margin-top:20px;">
          <el-button type="primary" size="mini" @click="dialogConfirm">{{ $t('BusinessIntelligence.common.save') }}</el-button>
          <el-button size="mini" @click="dialogCancel">{{ $t('BusinessIntelligence.common.cancel') }}</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 编辑我的图表 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editChart"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :show-close="false"
      :title="$t('BusinessIntelligence.businessIntelligenceChart.editChart')"
      :editable="true"
      width="800px"
    >
      <div class="filters" style="display:flex;">
        <div style="width:55%;">
          <el-form ref="editForm" :inline="true" :model="editChartForm" label-width="100px" :rules="rules" @submit.native.prevent>
            <el-form-item :label="$t('BusinessIntelligence.businessIntelligenceChart.chartName')" prop="grouping" :show-message="false">
              <el-input v-model="editChartForm.chartName" class="input-width" />
            </el-form-item>
            <el-form-item :label="$t('BusinessIntelligence.businessIntelligenceChart.chartGrouping')" prop="grouping" :show-message="false">
              <el-select v-model="editChartForm.grouping" class="input-width">
                <el-option
                  v-for="(item, index) in groupingList"
                  :key="index"
                  :label="item.name"
                  :value="item.uuid"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.ChartSource')" prop="chartSource" :show-message="false">
              <el-select v-model="editChartForm.chartSource" disabled class="input-width">
                <el-option
                  v-for="(item, index) in domaineNames"
                  :key="index"
                  :value="item"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('BusinessIntelligence.businessIntelligenceChart.remark')" prop="remark" :show-message="false">
              <el-input v-model="editChartForm.remark" type="textarea" :rows="7" class="input-width" />
            </el-form-item>
          </el-form>
          <div style="text-align:right;margin-top:30px;padding-right:30px;">
            <el-button type="primary" size="mini" @click="editConfirm">{{ $t('BusinessIntelligence.common.save') }}</el-button>
            <el-button size="mini" @click="editCancel">{{ $t('BusinessIntelligence.common.cancel') }}</el-button>
          </div>
        </div>
        <div class="edit-right">
          <div class="meta-base">
            <iframe
              id="eidtIframe"
              ref="editIframe"
              :src="editChartForm.url"
              frameborder="0"
              allowtransparency
              scrolling="no"
              width="100%"
              height="100%"
            />
            <div class="footer-mask" />
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getLoading } from '@/utils/utilBaseElement'
import { getDefaultBi, classify, getMyChart, addChart, deleteChart, editChart, chartConfig } from '@/api/sysManage/businessIntelligence/businessIntelligenceChart'
import { groupList } from '@/api/sysManage/businessIntelligence/chartGroupSetting'
export default {
  name: 'BusinessIntelligenceChart',
  data() {
    return {
      myChartNumber: {
        existing: 0,
        total: 0
      },
      domaineNames: [],
      editChart: false,
      editChartForm: {
        chartName: '',
        grouping: '',
        chartSource: '',
        remark: '',
        url: ''
      },
      chartForm: {
        chartName: '',
        grouping: '',
        chartSource: '',
        groupingType: 1,
        chartId: '',
        remark: ''
      },
      loading: false,
      addingCustomCharts: false,
      grouping: '',
      selectTemplateId: '',
      selectClassificationName: '',
      myChartValue: '',
      standardChartValue: '',
      groupingList: [],
      packetFilter: [],
      filterList: [],
      chartTemplate: [
        {
          name: this.$t('BusinessIntelligence.businessIntelligenceChart.selectAll'),
          id: ''
        },
        {
          name: this.$t('BusinessIntelligence.businessIntelligenceChart.hasChosen'),
          id: true
        },
        {
          name: this.$t('BusinessIntelligence.businessIntelligenceChart.notChoose'),
          id: false
        }
      ],
      classification: [this.$t('BusinessIntelligence.businessIntelligenceChart.selectAll')],
      metaBaseList: [],
      chartStandard: [],
      rules: {
        chartName: [
          {
            required: true
          }
        ],
        grouping: [
          {
            required: true
          }
        ],
        chartSource: [
          {
            required: true
          }
        ],
        chartId: [
          {
            required: true
          }
        ]
      }
    }
  },
  async created() {
    this.getGroupList()
    this.getMychartNumber() // 获取我的已用和总图表数量
    this.loading = getLoading()
    await this.getClassify()// 获取分类
    const p4 = this.standardChartList('created')// 获取标准图表库
    const p5 = this.myChartList('created') // 获取我的图表列表
    const that = this
    Promise.all([p4, p5]).then(() => {
      that.loading.close()
    }).catch(() => {
      that.loading.close()
    })
  },
  methods: {
    // 选择图表模板筛选项
    selectTemplate(id) {
      this.selectTemplateId = id
      this.standardChartList()
    },
    // 选择分类筛选项
    selectClassification(name) {
      this.selectClassificationName = name
      this.standardChartList()
    },
    // 分组切换
    selectGrouping(value) {
      if (value) {
        this.filterList = this.metaBaseList.filter((item) => {
          return item.groupUuid === value
        })
      } else {
        this.filterList = this.metaBaseList
      }
    },
    // 我的图表列表
    async myChartList(init) {
      const data = {
        searchData: this.myChartValue
      }
      this.loading = getLoading()
      const res = await getMyChart(data).finally(() => {
        if (init !== 'created') {
          this.loading.close()
        }
      })
      if (res.ok) {
        this.metaBaseList = res.data
        this.filterList = JSON.parse(JSON.stringify(res.data))
      }
    },
    // 标准图表列表
    async standardChartList(init) {
      const data = {}
      this.selectClassificationName === this.$t('BusinessIntelligence.businessIntelligenceChart.selectAll') ? '' : data.collectionName = this.selectClassificationName
      this.standardChartValue ? data.searchText = this.standardChartValue : ''
      this.selectTemplateId === '' ? '' : data.isSelected = this.selectTemplateId
      this.loading = getLoading()
      const res = await getDefaultBi(data).finally(() => {
        if (init !== 'created') {
          this.loading.close()
        }
      })
      if (res.ok) {
        this.chartStandard = res.data
      }
    },
    // 获取标准图表分类
    async getClassify() {
      const data = {
        biTenantId: this.$store.getters.tenantId
      }
      const res = await classify(data)
      if (res.ok) {
        if (res.data.length > 0) {
          this.selectClassificationName = res.data[0]
        }
        this.classification.push(...res.data)
      }
    },
    // 添加定制图表保存
    async dialogConfirm() {
      if (!this.chartForm.chartName.trim()) {
        this.$message.warning(this.$t('BusinessIntelligence.businessIntelligenceChart.chartNamePrompt'))
        return
      }
      if (!this.chartForm.chartSource.trim()) {
        this.$message.warning(this.$t('SystemMaintenance.EnterChartSource'))
        return
      }
      if (!this.chartForm.chartId.trim()) {
        this.$message.warning(this.$t('BusinessIntelligence.businessIntelligenceChart.chartIdPrompt'))
        return
      }
      const data = {
        chartId: Number(this.chartForm.chartId),
        name: this.chartForm.chartName,
        groupUuid: this.chartForm.grouping,
        chartSource: this.chartForm.chartSource,
        chartModel: 'card'
      }
      this.chartForm.remark ? data.remark = this.chartForm.remark : ''
      this.dialogAddChartFunc(data)
    },
    // 添加图表接口函数
    dialogAddChartFunc(data, checked, item) {
      this.loading = getLoading()
      addChart(data).then((res) => {
        if (res.ok) {
          this.dialogCancel()
          this.$message.success(this.$t('BusinessIntelligence.businessIntelligenceChart.addSuccess'))
          this.myChartList()
          this.getMychartNumber()
        }
        this.loading.close()
      }).catch((err) => {
        if (checked === 'checked') {
          item.selected = 0
        }
        this.loading.close()
      })
    },
    // 编辑保存
    async editConfirm() {
      if (!this.editChartForm.chartName.trim()) {
        this.$message.warning(this.$t('BusinessIntelligence.businessIntelligenceChart.chartNamePrompt'))
        return
      }
      if (!this.editChartForm.chartSource.trim()) {
        this.$message.warning(this.$t('SystemMaintenance.EnterChartSource'))
        return
      }
      const data = {
        name: this.editChartForm.chartName,
        chartModel: this.editChartForm.chartModel,
        groupUuid: this.editChartForm.grouping,
        chartSource: this.editChartForm.chartSource,
        chartId: this.editChartForm.chartId
      }
      this.editChartForm.remark ? data.remark = this.editChartForm.remark : ''
      this.loading = getLoading()
      const res = await editChart(data).finally(() => {
        this.loading.close()
      })
      if (res.ok) {
        this.$message.success(this.$t('BusinessIntelligence.common.saveSuccess'))
        this.editCancel()
        this.myChartList()
      }
    },
    // 删除我的图表
    async deletes(item) {
      const data = {
        chartId: item.chartId
      }
      this.loading = getLoading()
      const res = await deleteChart(data).finally(() => {
        this.loading.close()
      })
      if (res.ok) {
        this.standardChartList()
        this.getMychartNumber()
        this.myChartList()
        this.$message.success(this.$t('BusinessIntelligence.businessIntelligenceChart.deleteSuccess'))
      }
    },
    // 我的图表数和可用图表数
    async getMychartNumber() {
      const res = await chartConfig()
      if (res.ok) {
        this.myChartNumber.existing = res.data.biDashboardUsedCount
        this.myChartNumber.total = res.data.biDashboardFreeLimit + res.data.biDashboardPayLimit
        this.domaineNames = Array.from(res.data.biDomainName.split('|'), p => p.trim())
      }
    },
    // 获取分组下拉列表
    async getGroupList() {
      const data = {
        includeCharts: false
      }
      const res = await groupList(data)
      if (res.ok) {
        this.groupingList = res.data
        this.packetFilter = [
          {
            name: '全部图表',
            uuid: ''
          }
        ]
        this.packetFilter.push(...res.data)
      }
    },
    // 图表上限时提醒
    addChartFunc(checked, item) {
      if (this.myChartNumber.total <= this.myChartNumber.existing) {
        this.$confirm(this.$t('BusinessIntelligence.businessIntelligenceChart.warmPromptStatements').replace('${0}', this.myChartNumber.existing), this.$t('BusinessIntelligence.businessIntelligenceChart.warmPrompt'), {
          confirmButtonText: this.$t('BusinessIntelligence.businessIntelligenceChart.confirmButtonText'),
          showCancelButton: false,
          type: 'warning'
        })
        if (checked === 'checked') {
          item.selected = 0
        }
      } else {
        if (checked === 'checked') {
          // 勾选标准图表库添加到我的图表库
          const groupItem = this.groupingList.filter((i) => {
            return i.name === (item.businessType === 0 ? '业务图表' : '财务图表')
          })
          const data = {
            chartId: item.chartId,
            name: item.name,
            groupUuid: groupItem[0].uuid,
            chartModel: item.chartModel
          }
          this.dialogAddChartFunc(data, checked, item)
        } else {
          const groupItem = this.groupingList.filter((i) => {
            return i.name === '业务图表'
          })
          this.chartForm.grouping = groupItem[0].uuid
          this.addingCustomCharts = true
        }
      }
    },
    // 编辑弹窗
    edit(item) {
      this.editChart = true
      this.editChartForm = {
        ...item,
        chartName: item.name,
        grouping: item.groupUuid,
        remark: item.remark
      }
    },
    // 编辑取消
    editCancel() {
      this.$refs['eidtForm'] ? this.$refs['eidtForm'].resetFields() : ''
      this.editChart = false
      this.editChartForm = {
        chartName: '',
        grouping: '',
        chartSource: '',
        chartId: '',
        remark: ''
      }
    },
    // 添加定制图表取消
    dialogCancel() {
      this.$refs['addForm'] ? this.$refs['addForm'].resetFields() : ''
      this.addingCustomCharts = false
      this.chartForm = {
        chartName: '',
        grouping: '',
        chartSource: '',
        chartId: '',
        groupingType: 1,
        remark: ''
      }
    }
  }
}
</script>
<style lang="scss">
  .businessIntelligenceChart{
    .el-checkbox__inner{
      border-color: #1F75D5 !important;
    }
    .content{
      height: 100% !important;
      display: flex;
      margin-top:5px;
      justify-content: space-between;
      flex-direction: row;
      overflow: hidden;
      .item-left, .item-right{
        overflow: hidden;
        padding: 10px 5px;
        box-sizing: border-box;
        flex:1;
        background-color: #fff;
      }
      .mar-left{
        margin-left:5px;
      }
      .my-chart{
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #ccc;
        height: 40px;
        align-items: center;
        .my-chart-right{
          padding-bottom: 10px;
          box-sizing: border-box;
          display: flex;
        }
      }
      .chart-list{
        overflow-x: hidden;
        overflow-y: scroll;
        flex:1;
        .item{
          margin-bottom: 15px;
          display: flex;
          flex-direction: column;
          height:280px;
          .operation{
            width: 100%;
            height: 50px;
            background: #FFF;
            padding: 0 5px 10px 5px;
            box-sizing: border-box;
            display: flex;
            align-items: flex-end;
            justify-content: space-between;
            position: absolute;
            bottom: 0;
            left: 0;
            .disable{
              position: absolute;
              bottom: 12px;
              right: 5px;
              width: 15px;
              height: 15px;
              z-index: 20;
            }
            i{
              font-size: 16px;
              cursor: pointer;
            }
          }
        }
      }
    }
    .screening{
      display: flex;
      flex-direction: column;
      border-bottom: 1px solid #ccc;
      .classification{
        padding-bottom: 10px;
        box-sizing: border-box;
      }
      .chart-template, .classification{
        font-size: 13px;
        margin-top:10px;
        display: flex;
        align-items: baseline;
        .text{
          width: 60px;
          text-align: right;
          display: inline-block;

        }
        .item{
          cursor: pointer;
          display: inline-block;
          padding: 5px 10px;
          border-radius: 4px;
          margin-bottom:5px;
        }
      }
    }
    .selectColor{
      background: #E8F1FB;
      color: #1F75D5;
    }
    .input-width{
      width:300px !important;
    }
    .edit-right{
      width: 245px;
      display: flex;
      flex-direction: column;
      span{
        height:20px;
        line-height: 20px;
        display: inline-block;
      }
      .meta-base{
        width: 100%;
        flex: 1;
        position: relative;
        .footer-mask{
          position: absolute;
          bottom: 0;
          left:0;
          width: 100%;
          height:45px;
          background: #fff;
        }
      }
    }
    .set-input{
      height:28px;
      border: 1px solid #DCDFE6;
      text-indent: 6px;
      font-size:12px;
      &:focus{
        outline-style: none;
        border: 1px solid #226cc1;
        border-radius: 1px;
      }
    }
  }
</style>
